module.exports = __webpack_public_path__ + "static/contactscroll-4e3270f4bc95195dd695f2682827640a.jpg";